var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditInCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 47,
    viewBox: "0 0 164 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 163.081,
    height: 46.524,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 162.081,
    height: 45.524,
    rx: 9.5,
    stroke: "#35475A",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "#7D2AE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint0_radial_1_31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint1_radial_1_31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint2_radial_1_31)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint3_radial_1_31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.262C8 31.691 14.8329 38.524 23.2618 38.524C31.691 38.524 38.524 31.691 38.524 23.262C38.524 14.833 31.691 8 23.2618 8C14.8329 8 8 14.833 8 23.262Z",
    fill: "url(#paint4_radial_1_31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4088 26.1368C29.3008 26.1368 29.2068 26.2278 29.1078 26.4258C27.9968 28.6798 26.0766 30.2748 23.855 30.2748C21.2862 30.2748 19.6955 27.9558 19.6955 24.7518C19.6955 19.3258 22.719 16.1878 25.3746 16.1878C26.6155 16.1878 27.3733 16.9678 27.3733 18.2088C27.3733 19.6818 26.5365 20.4618 26.5365 20.9808C26.5365 21.2148 26.6816 21.3558 26.9692 21.3558C28.1248 21.3558 29.4808 20.0278 29.4808 18.1518C29.4808 16.3328 27.8978 14.9968 25.2424 14.9968C20.8536 14.9968 16.9531 19.0648 16.9531 24.6948C16.9531 29.0528 19.4416 31.9328 23.2812 31.9328C27.3565 31.9328 29.7128 27.8778 29.7128 26.5618C29.7128 26.2708 29.5638 26.1368 29.4088 26.1368Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.524 30.0545V16.4695H55.549V18.2935H48.519V22.2265H54.732V23.9935H48.519V28.2305H55.53V30.0545H46.524Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0569 30.3205C59.2519 30.3205 57.0479 28.9525 57.0479 25.4565C57.0479 22.1315 59.0619 20.6685 60.9619 20.6685C62.4629 20.6685 63.3939 21.5615 63.8689 22.2835H63.8879V16.4695H65.8069V30.0545H63.8879V28.7245H63.8689C63.4509 29.4275 62.5199 30.3205 61.0569 30.3205ZM61.4369 28.7435C62.9189 28.7435 63.9259 27.3945 63.9259 25.3805C63.9259 23.3665 62.9189 22.2835 61.4179 22.2835C60.0119 22.2835 58.9859 23.2525 58.9859 25.3805C58.9859 27.5655 60.0499 28.7435 61.4369 28.7435Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0434 30.0545V20.9535H69.9624V30.0545H68.0434ZM69.0124 19.3575C68.2334 19.3575 67.6824 18.8255 67.6824 18.1225C67.6824 17.4195 68.2334 16.8685 69.0124 16.8685C69.7724 16.8685 70.3234 17.4195 70.3234 18.1225C70.3234 18.8255 69.7724 19.3575 69.0124 19.3575Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7359 30.3015C74.0829 30.3015 73.2659 29.3515 73.2659 28.1925V22.5115H71.5179V20.9535H72.7149C73.1519 20.9535 73.3229 20.7825 73.3229 20.3455V18.5025L75.1849 18.0845V20.9535H77.3699V22.5115H75.1849V27.8125C75.1849 28.3635 75.4319 28.6865 76.0969 28.6865C76.3439 28.6865 76.7239 28.6295 77.0659 28.4585L77.4649 29.9215C76.9709 30.1495 76.4199 30.3015 75.7359 30.3015Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4829 30.0545V20.9535H86.4019V30.0545H84.4829ZM85.4519 19.3575C84.6729 19.3575 84.1219 18.8255 84.1219 18.1225C84.1219 17.4195 84.6729 16.8685 85.4519 16.8685C86.2119 16.8685 86.7629 17.4195 86.7629 18.1225C86.7629 18.8255 86.2119 19.3575 85.4519 19.3575Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5463 30.0545V20.9535H90.4653V22.3405H90.4843C90.9973 21.1815 92.1183 20.6685 93.3343 20.6685C94.9113 20.6685 96.3933 21.5615 96.3933 23.7275V30.0545H94.4743V24.1265C94.4743 23.0245 93.8853 22.3025 92.8023 22.3025C91.5293 22.3025 90.4653 23.2905 90.4653 25.2095V30.0545H88.5463Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.801 30.3585C106.457 30.3585 103.474 28.0785 103.474 23.2335C103.474 18.4265 106.457 16.1655 109.725 16.1655C112.689 16.1655 114.57 18.0275 115.273 20.6685L113.221 21.2955C112.708 19.2055 111.492 17.9705 109.63 17.9705C107.407 17.9705 105.564 19.7185 105.564 23.2335C105.564 26.7485 107.426 28.5535 109.801 28.5535C111.644 28.5535 112.841 27.4135 113.164 25.5515L115.216 25.9505C114.684 28.4965 112.898 30.3585 109.801 30.3585Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.953 30.3205C118.091 30.3205 116.875 29.2755 116.875 27.6795C116.875 26.1025 118.129 25.0195 120.675 24.6015L122.157 24.3545C122.936 24.2215 123.126 24.0505 123.126 23.6135C123.126 22.7965 122.385 22.2075 121.245 22.2075C120.105 22.2075 119.231 22.7965 118.889 23.8035L117.331 22.9295C117.882 21.5045 119.345 20.6495 121.302 20.6495C123.696 20.6495 125.026 21.9225 124.969 24.0695L124.855 27.9265C124.836 28.5345 125.102 28.8195 125.653 28.7625V30.2445C125.463 30.2825 125.235 30.3015 125.007 30.3015C123.639 30.3015 123.164 29.5985 123.126 28.1545H123.107C122.67 29.5415 121.53 30.3205 119.953 30.3205ZM120.238 28.7625C121.777 28.7625 123.069 27.5275 123.107 26.0645L123.126 25.1715C122.917 25.4565 122.594 25.5895 122.005 25.7225L120.922 25.9505C119.364 26.2735 118.794 26.7295 118.794 27.5465C118.794 28.3065 119.288 28.7625 120.238 28.7625Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.4 30.0545V20.9535H129.319V22.3405H129.338C129.851 21.1815 130.972 20.6685 132.188 20.6685C133.765 20.6685 135.247 21.5615 135.247 23.7275V30.0545H133.328V24.1265C133.328 23.0245 132.739 22.3025 131.656 22.3025C130.383 22.3025 129.319 23.2905 129.319 25.2095V30.0545H127.4Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.007 30.0545L136.53 20.9535H138.563L141.052 28.0785L143.484 20.9535H145.479L142.002 30.0545H140.007Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 30.3205C147.519 30.3205 146.303 29.2755 146.303 27.6795C146.303 26.1025 147.557 25.0195 150.103 24.6015L151.585 24.3545C152.364 24.2215 152.554 24.0505 152.554 23.6135C152.554 22.7965 151.813 22.2075 150.673 22.2075C149.533 22.2075 148.659 22.7965 148.317 23.8035L146.759 22.9295C147.31 21.5045 148.773 20.6495 150.73 20.6495C153.124 20.6495 154.454 21.9225 154.397 24.0695L154.283 27.9265C154.264 28.5345 154.53 28.8195 155.081 28.7625V30.2445C154.891 30.2825 154.663 30.3015 154.435 30.3015C153.067 30.3015 152.592 29.5985 152.554 28.1545H152.535C152.098 29.5415 150.958 30.3205 149.381 30.3205ZM149.666 28.7625C151.205 28.7625 152.497 27.5275 152.535 26.0645L152.554 25.1715C152.345 25.4565 152.022 25.5895 151.433 25.7225L150.35 25.9505C148.792 26.2735 148.222 26.7295 148.222 27.5465C148.222 28.3065 148.716 28.7625 149.666 28.7625Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8958 35.054) rotate(-49.4156) scale(23.6075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0807 11.47) rotate(54.7035) scale(26.6218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8958 35.054) rotate(-45.1954) scale(23.3217 10.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4825 12.113) rotate(66.5198) scale(24.0311 40.2574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.1327 8.865) rotate(48.8515) scale(25.7307 43.1046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInCanva);
export default __webpack_public_path__ + "static/media/edit-in-canva.ca0924743f2e011c2bac23a65aa1a1b1.svg";
export { ForwardRef as ReactComponent };